import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    minHeight: '100vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap' as const,
    gap: theme.spacing(2),
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#1F2937',
  },
  dateControls: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap' as const,
  },
  presetButton: {
    textTransform: 'none' as const,
    borderRadius: 8,
    fontWeight: 500,
    fontSize: 13,
    minWidth: 'auto',
    padding: '4px 12px',
  },
  activePreset: {
    backgroundColor: '#3B82F6',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#2563EB',
    },
  },
  dateInput: {
    fontSize: 13,
    padding: '6px 8px',
    borderRadius: 6,
    border: '1px solid #D1D5DB',
    outline: 'none',
    '&:focus': {
      borderColor: '#3B82F6',
    },
  },
  summaryCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  summaryCard: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: theme.spacing(2.5),
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  cardLabel: {
    fontSize: 13,
    color: '#6B7280',
    fontWeight: 500,
    marginBottom: 4,
  },
  cardValue: {
    fontSize: 28,
    fontWeight: 700,
    color: '#1F2937',
  },
  chartContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: theme.spacing(2.5),
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    marginBottom: theme.spacing(3),
  },
  chartTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: '#1F2937',
    marginBottom: theme.spacing(2),
  },
  chartRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  tableContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
  },
  th: {
    textAlign: 'left' as const,
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 600,
    color: '#6B7280',
    borderBottom: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
  },
  td: {
    padding: '12px 16px',
    fontSize: 14,
    color: '#1F2937',
    borderBottom: '1px solid #F3F4F6',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
  },
  emptyState: {
    textAlign: 'center' as const,
    padding: theme.spacing(6),
    color: '#9CA3AF',
  },
  backButton: {
    marginBottom: theme.spacing(2),
    textTransform: 'none' as const,
    borderRadius: 8,
    fontWeight: 600,
  },
}));
